import { render } from "./ButtonProperty1SecondaryHoverFalse.vue?vue&type=template&id=520508cc&scoped=true"
import script from "./ButtonProperty1SecondaryHoverFalse.vue?vue&type=script&lang=js"
export * from "./ButtonProperty1SecondaryHoverFalse.vue?vue&type=script&lang=js"

import "./ButtonProperty1SecondaryHoverFalse.vue?vue&type=style&index=0&id=520508cc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520508cc"]])

export default __exports__